import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const runAgentPromptTest = unaryRpc({
  name: "runAgentPromptTest",
  input: z.object({
    agentName: z.string(),
    teamId: z.string(),
    testPromptTemplate: z.string(),
  }),
  output: z.object({
    originalResponse: z.string(),
    testResponse: z.string(),
    error: z.string().optional(),
  }),
});
